<div>
  <slot />
</div>
